// refactor sass to stylejs (no theme usage)
import { styled } from '@mui/material/styles';
import { css } from '@emotion/react';

export const StyledSmallSearch = styled('div')(
  () => css`
    &.is-header-variant {
      flex: 1;
      min-width: 0;
      width: 100%;

      .small-search {
        height: auto;
        display: flex;
        justify-content: stretch;
        align-items: center;
        position: relative;

        .search-form {
          display: flex;
          align-items: flex-start;
          gap: 12px;
          width: 100%;
          position: relative;

          .form-input-anchor {
            flex: 1;
            min-width: 0;
            position: relative;
          }

          .search-history-dropdown {
            position: absolute;
            top: calc(100% + 4px);
            left: 0;
            right: 0;
            z-index: 1300;
            background: #fff;
            border: 1px solid #ededed;
            border-radius: 8px;
            box-shadow: 0 15px 36px rgba(0, 0, 0, 0.06),
              0 3px 8px -1px rgba(50, 50, 71, 0.05);
          }

          .form-input {
            width: 100%;

            .MuiOutlinedInput-root {
              background: #fcfcfc;
              border-radius: 8px;
              min-height: 48px;
              align-items: flex-start;

              fieldset {
                border-color: #f5f5f5;
              }

              &:hover fieldset {
                border-color: #f5f5f5;
              }

              &.Mui-focused fieldset {
                border-color: #37aaaf;
              }
            }

            > div {
              padding: 12px;
            }

            input,
            textarea {
              max-height: 74px;
              overflow-y: auto !important;
              padding: 0;
              font-size: 14px;
              line-height: 20px;
              color: #0c395a;
            }
          }

          .form-button {
            margin-right: 0;
            padding: 0 24px !important;
            min-height: 48px;
            height: 48px;
            border-radius: 8px;
            flex-shrink: 0;
            align-self: flex-start;
            display: inline-flex !important;
            align-items: center !important;
            justify-content: center !important;
            line-height: 20px;

            > span {
              display: inline-flex;
              align-items: center;
              justify-content: center;
              line-height: 20px;
            }
          }
        }

        .search-form-input-helper {
          text-align: left;
          position: absolute;
          bottom: -22px;
          left: 0;
          color: #f44336;
          margin: 0;
          font-size: 0.75rem;
        }
      }
    }

    .small-search {
      height: 200px;
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      .search-lines {
        width: 2280px;
        position: absolute;
        right: -270px;
        top: -435px;
        z-index: -1;
      }
      .search-form {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 90%;
        position: relative;
        .form-input-anchor {
          flex: 1;
          min-width: 0;
          position: relative;
        }
        .search-history-dropdown {
          position: absolute;
          top: calc(100% + 4px);
          left: 0;
          right: 0;
          z-index: 1300;
          background: #fff;
          border: 1px solid #ededed;
          border-radius: 8px;
          box-shadow: 0 15px 36px rgba(0, 0, 0, 0.06),
            0 3px 8px -1px rgba(50, 50, 71, 0.05);
        }
        .form-input {
          > div {
            padding: 12.5px 14px;
          }
          input {
            max-height: 60px;
          }
          textarea {
            max-height: 74px;
            overflow-y: auto !important;
          }
        }
        .form-button {
          margin-right: 10px;
          padding: 8px 50px !important;
        }
      }
      .search-form-input-helper {
        text-align: left;
        position: absolute;
        bottom: -25px;
        left: 142px;
        color: #f44336;
        margin: 0;
        font-size: 0.75rem;
      }
    }

    @media (max-width: 1600px) {
      &:not(.is-header-variant) .small-search {
        .search-lines {
          width: 2080px;
          position: absolute;
          right: -250px;
          top: -380px;
          z-index: -1;
        }
      }
    }

    @media (max-width: 1400px) {
      &:not(.is-header-variant) .small-search {
        .search-lines {
          width: 1900px;
          position: absolute;
          right: -250px;
          top: -338px;
          z-index: -1;
        }
      }
    }

    @media (max-width: 1200px) {
      &:not(.is-header-variant) .small-search {
        .search-lines {
          width: 1500px;
          position: absolute;
          right: -182px;
          top: -245px;
          z-index: -1;
        }
      }
    }

    @media (max-width: 1100px) {
      &:not(.is-header-variant) .small-search {
        .search-lines {
          width: 1300px;
          position: absolute;
          right: -143px;
          top: -193px;
          z-index: -1;
        }
      }
    }

    @media (max-width: 960px) {
      &:not(.is-header-variant) .small-search {
        align-items: flex-end;
        height: 80px;

        .search-form {
          position: relative;
          bottom: 5px;
          width: 85%;
          .form-input {
            input {
              max-height: 25px;
            }
            textarea {
              max-height: 25px;
            }
          }
          .form-button {
            padding: 8px 20px !important;
          }
        }

        .search-lines {
          top: -250px;
        }
      }
    }

    @media only screen and (max-width: 600px) {
      &:not(.is-header-variant) .small-search {
        .search-form {
          width: 100%;
        }
      }

      /**
       * روی موبایل اینپوت یک سطر کامل می‌گیرد و دکمه‌ها به سطر بعد می‌روند
       * و به انتهای سطر (سمت چپ در چیدمان راست‌به‌چپ) می‌چسبند
       */
      &.is-header-variant .small-search .search-form {
        flex-wrap: wrap;
        justify-content: flex-end;

        .form-input-anchor {
          flex: 1 0 100%;
        }
      }
    }
  `
);
